module.exports = __webpack_public_path__ + "static/media/girl in room.f6a8229f.png";